import React, { FC, useMemo, useState } from 'react';
import JoditEditor                      from 'jodit-react';
import {Jodit}                            from 'jodit';
import Style                            from './Editor.style';

type TProps = {
  height?: number;
  placeholder?: string;
  value?: string;
  defaultValue?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
}

export const Editor: FC<TProps> = ({ placeholder, value, defaultValue, onChange, disabled, height = 800 }) => {
  const [ content, setContent ] = useState(defaultValue ?? value ?? '');

  const config = useMemo(() => ({
    readonly: false, // all options from https://xdsoft.net/jodit/docs/,
    placeholder: placeholder || 'Bitte Text eingeben...',
    height,
    removeButtons: [ 'font', 'lineHeight', 'fontsize', 'left', 'indent', 'outdent', 'brush', 'dots', 'about', 'print', 'find', 'ai-commands', 'ai-assistant', 'file', 'image', 'video', 'classSpan', 'spellcheck', 'speechRecognize', 'source' ],
    pasteHTMLActionList: [
      {
        text: 'Einfügen',
        value: 'custom'
      }
    ],
    events: {
      onCustomPasteHTMLOption: (action: string, html: string) => {
        if (action === 'custom') {
          return html
          .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
          .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
          .replace(/\s*style="[^"]*"/gi, '')
          .replace(/\s*class="[^"]*"/gi, '')
          .replace(/<h1>/gi, '<h2>')
          .replace(/<\/h1>/gi, '</h2>');
        }
      }
    },
    controls: {
      paragraph: {
        list: Jodit.atom ({
          h2: 'Überschrift 1',
          h3: 'Überschrift 2',
          h4: 'Überschrift 3',
          p: 'Absatz',
          blockquote: 'Zitat',
        })
      }
    },
  }), [ placeholder, height ]);

  const handleOnChange = (value: string) => {
    onChange && onChange(value);
  };

  return (
    <Style>
      {disabled ? <div className="disableEditor"/> : null}
      <JoditEditor
        value={content}
        config={config}
        tabIndex={2}
        onBlur={newContent => setContent(newContent)}
        onChange={handleOnChange}
      />
    </Style>
  );
};
